import {findAllDotPaths} from './finders'
import {setOnPath, getValueFromString} from './utils'

export function setKeysFromPartial<T extends object>(target: T, arg: Partial<T>): T {
  [].concat(findAllDotPaths(arg)).forEach(
    path =>
      setOnPath(target, path, getValueFromString(arg, path))
  )
  return target
}